(() => {
  const initRomilowScentExperience = () => {
    const source = document.querySelector('[data-romilow-smells-like]');
    const card = document.querySelector('.romilow-scent-card');
    if (!card || card.dataset.romilowScentReady === 'true') return;

    const grid = card.querySelector('.romilow-scent-card__grid');
    if (!grid) return;

    const smellsLike = source ? source.textContent.trim() : '';
    if (smellsLike) {
      const experience = document.createElement('div');
      experience.className = 'romilow-scent-card__experience';
      experience.innerHTML = '<span class="romilow-scent-card__experience-label">Smells Like</span><p></p>';
      experience.querySelector('p').textContent = smellsLike;
      grid.before(experience);
    }

    Array.from(grid.querySelectorAll('dt')).forEach((term) => {
      const label = term.textContent.trim().toLowerCase();
      if (['top notes', 'heart notes', 'base notes'].includes(label)) {
        const definition = term.nextElementSibling;
        term.remove();
        if (definition && definition.tagName === 'DD') definition.remove();
      }
    });

    card.dataset.romilowScentReady = 'true';
  };

  const initRomilowMobileATC = () => {
    document.querySelectorAll('[data-romilow-mobile-atc]').forEach((bar) => {
      if (bar.dataset.romilowReady === 'true') return;

      const section = bar.closest('section');
      const primary = section && section.querySelector('.product-form__submit');
      const sticky = bar.querySelector('[data-romilow-sticky-submit]');
      const price = bar.querySelector('.romilow-mobile-atc__price');
      const sectionId = bar.dataset.sectionId;

      if (!primary || !sticky) return;

      bar.dataset.romilowReady = 'true';
      bar.hidden = false;

      const sync = () => {
        const primaryLabel = primary.querySelector('span');
        sticky.disabled = primary.disabled;
        sticky.textContent = primaryLabel && primaryLabel.textContent.trim()
          ? primaryLabel.textContent.trim()
          : 'Add to cart';

        const priceContainer = sectionId ? document.getElementById(`price-${sectionId}`) : null;
        if (price && priceContainer) {
          const salePrice = priceContainer.querySelector('.price-item--sale');
          const regularPrice = priceContainer.querySelector('.price-item--regular');
          const activePrice = salePrice || regularPrice;
          if (activePrice && activePrice.textContent.trim()) {
            price.textContent = activePrice.textContent.trim();
          }
        }
      };

      const updateVisibility = () => {
        const passedPrimaryCTA = primary.getBoundingClientRect().bottom < 0;
        bar.classList.toggle(
          'is-visible',
          window.innerWidth < 750 && passedPrimaryCTA
        );
      };

      sticky.addEventListener('click', () => {
        if (!primary.disabled) primary.click();
      });

      new MutationObserver(() => {
        sync();
        updateVisibility();
      }).observe(primary, {
        attributes: true,
        childList: true,
        subtree: true
      });

      const priceContainer = sectionId ? document.getElementById(`price-${sectionId}`) : null;
      if (priceContainer) {
        new MutationObserver(sync).observe(priceContainer, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);

      sync();
      updateVisibility();
    });
  };

  const initRomilowPDP = () => {
    initRomilowScentExperience();
    initRomilowMobileATC();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRomilowPDP);
  } else {
    initRomilowPDP();
  }

  document.addEventListener('shopify:section:load', initRomilowPDP);
})();
